import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { AptitudeAvis } from '../models/options/situationProfessionnelles/aptitudesAvis';

const resource = 'AptitudesAvis'

export default class AptitudesAvisResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<AptitudeAvis>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
